import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientConsultNoteVerification } from '../../../core/models/client-consult-note-verification.model';
import { LimitOffsetPaging } from '../../../core/models/paged-results/limit-offset-paging.model';
import { FormsModule } from '@angular/forms';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';

import { ClientConsultNoteTaskDateComponent } from '../client-consult-note-task-date/client-consult-note-task-date.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-client-consult-note-task-dates',
    templateUrl: './client-consult-note-task-dates.component.html',
    styleUrls: ['./client-consult-note-task-dates.component.scss'],
    imports: [FormsModule,
              PaginationHeaderComponent,
              PaginationComponent,
              ClientConsultNoteTaskDateComponent,
              FaIconComponent]
})
export class ClientConsultNoteTaskDatesComponent {
  @Input() verifications: ClientConsultNoteVerification[];
  @Input() formDisabled : boolean;
  @Input() paging : LimitOffsetPaging;

  @Output() updateVerification = new EventEmitter<{ id: number; encounterDate: string }>();
  @Output() removeVerification = new EventEmitter<number>();
  @Output() addVerification = new EventEmitter();
  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<number>();

  onUpdate(verification: { id: number; encounterDate: string }) {
    this.updateVerification.emit(verification);
  }

  onRemove(id: number) {
    this.removeVerification.emit(id);
  }

  onAddClick($event) {
    $event.preventDefault();
    this.addVerification.emit();
  }

  onPageSizeChange($event) {
    this.pageSizeChange.emit($event);
  }

  onPageChange($event) {
    this.pageChange.emit($event);
  }
}
